import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { StepProps } from '../../../../components/_WMS/Stepper'
import { SharedStateType } from '../../types'

interface ErrorMessageProps extends StepProps<SharedStateType> {}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '80vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.default
  },
  errorText: {
    color: '#B71C1C', // Softer red for error
    backgroundColor: '#fdecea', // Softer light red background
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    textAlign: 'center',
    maxWidth: '80%'
  }
}))

export const ErrorStep: React.FC<ErrorMessageProps> = ({
  priorStep,
  goToStep,
  sharedState: { error }
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Typography variant='h6' className={classes.errorText}>
        {error}
      </Typography>
      <Button onClick={() => goToStep(priorStep)}>Volver</Button>
    </Box>
  )
}
